import { ERP } from '../_base/endpoint';
import axios from 'axios';

class motivoTrasladoService {
    async listar() {
        const response = await axios
            .get(`${ERP}logistica/motivo-traslado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}
export default new motivoTrasladoService();